import { ERarity } from "../interfaces/crawl.interface"

export const getRarity = (rarity: ERarity | undefined): number => {
    switch (rarity) {
        case ERarity.N:
            return 13
        case ERarity.R:
            return 23
        case ERarity.SR:
            return 24
        case ERarity.SSR:
            return 25
        default:
            return 13
    }
}

export const waitFor = (timeout: number) => new Promise((resolve) => {
    setTimeout(() => {
        resolve(true)
    }, timeout);
});



export const convertArrayToObject = (array: any[], key: any) => {
    const initialValue = {};
    return array.reduce((obj, item) => {
        return {
            ...obj,
            [item[key]]: item.value,
        };
    }, initialValue);
};

